import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy /account/user/prescriptions = 10-line redirect to /medical-vault.
 * Port preserves the same destination — Rx feed lives inside the vault
 * (passport tab).
 */
export const Route = createFileRoute("/_authenticated/account/user/prescriptions")({
  beforeLoad: () => {
    throw redirect({
      to: "/account/user/medical-vault",
      search: { tab: "passport", subtab: "active" } as never,
    });
  },
});
